<template>
  <form-section
    :title="$t('ProjectSettings_EngagementCategories_Settings_Title')"
    class="outer-form"
  >
    <el-row>
      <el-col :span="24">
        <el-row>
          <el-col :span="6">
            <rest-form-item
              :label="$t('Engagement_Category_Title')"
              prop="title"
            >
              <el-input :disabled="readOnly" v-model="model.title" />
            </rest-form-item>
          </el-col>
          <el-col :span="6">
            <segment-select
              prop="segment_id"
              v-model="model.segment_id"
              :label="$t('Engagement_Category_Segments')"
              :placeholder="$t('Category_Segments_Placeholder')"
              clearable
              :tooltip="$t('Engagement_Category_Segments_Hint')"
              :read-only="readOnly"
            />
          </el-col>
          <el-col :span="6">
            <rest-form-item
              :label="$t('Engagement_Category_National_Exclusion_Check')"
              prop="national_exclusion_check"
              v-if="
                model.use_national_exclusion && isNationalExclusionAvailable
              "
            >
              <template v-if="isBetssonEnabled && isOasisEnabled">
                <grouped-prefix-select
                  v-model="model.national_exclusion_check"
                  :value="model.national_exclusion_check"
                  :groups="groupedExclusionTypes"
                  :disabled="readOnly"
                  :number="true"
                />
              </template>
              <grouped-prefix-select
                v-else
                :value="model.national_exclusion_check"
                v-model="model.national_exclusion_check"
                :groups="filteredExclusionTypes"
                :disabled="readOnly"
                :number="true"
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-row>
          <el-col :span="4">
            <rest-form-item prop="ignore_subscription">
              <el-switch
                :disabled="readOnly"
                v-model="model.ignore_subscription"
              />
              <template #label>
                {{ $t('Engagement_Category_Ignore_Subscription') }}
                <form-item-i-tooltip
                  :tooltip-content="
                    $t('Engagement_Category_Ignore_Subscription_Hint')
                  "
                />
              </template>
            </rest-form-item>
          </el-col>
          <el-col :span="4" v-if="isNationalExclusionAvailable">
            <rest-form-item
              :label="$t('Engagement_Category_Use_National_Exclusion')"
              prop="use_national_exclusion"
            >
              <el-switch
                :disabled="readOnly"
                v-model="model.use_national_exclusion"
              />
            </rest-form-item>
          </el-col>
          <el-col :span="4">
            <rest-form-item prop="collapse">
              <el-switch :disabled="readOnly" v-model="model.collapse" />
              <template #label>
                {{ $t('Engagement_Category_Collapse') }}
                <form-item-i-tooltip
                  :tooltip-content="$t('Engagement_Category_Collapse_Hint')"
                />
              </template>
            </rest-form-item>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection.vue'
import RestFormItem from '@/common/components/rest/RestFormItem'
import {
  nationalExclusionTypeLabels,
  nationalExclusionTypes
} from '@/common/enum/CategoryEnums'
import FormItemITooltip from '@/common/components/form/FormItemITooltip.vue'
import GroupedPrefixSelect from '@/common/components/form/GroupedPrefixSelect.vue'
import SegmentSelect from '@/common/components/segment/SegmentSelect.vue'

export default {
  name: 'EngagementCategoriesSettingsSection',
  components: {
    SegmentSelect,
    GroupedPrefixSelect,
    RestFormItem,
    FormSection,
    FormItemITooltip
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    isNationalExclusionAvailable: {
      type: Boolean,
      required: true
    },
    isBetssonEnabled: {
      type: Boolean,
      required: true
    },
    isOasisEnabled: {
      type: Boolean,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      nationalExclusionTypes,
      nationalExclusionTypeLabels,
      loadingSegments: false,
      segments: {}
    }
  },
  computed: {
    filteredExclusionTypes() {
      if (this.isOasisEnabled) {
        return [this.groupedExclusionTypes[1]]
      }
      return [this.groupedExclusionTypes[0]]
    },
    groupedExclusionTypes() {
      let techsson = {}
      techsson[nationalExclusionTypes.marketing] = this.getOptionName(
        nationalExclusionTypes.marketing
      )
      techsson[nationalExclusionTypes.service] = this.getOptionName(
        nationalExclusionTypes.service
      )
      techsson[nationalExclusionTypes.general] = this.getOptionName(
        nationalExclusionTypes.general
      )

      let oasis = {}
      oasis[nationalExclusionTypes.marketing_oasis] = this.getOptionName(
        nationalExclusionTypes.marketing_oasis
      )
      oasis[nationalExclusionTypes.marketing_bonus_oasis] = this.getOptionName(
        nationalExclusionTypes.marketing_bonus_oasis
      )

      return [
        {
          groupDesc: this.getOptionGroupDesc('techsson'),
          groupTitle: this.getOptionGroupName('techsson'),
          options: techsson
        },
        {
          groupDesc: this.getOptionGroupDesc('oasis'),
          groupTitle: this.getOptionGroupName('oasis'),
          options: oasis
        }
      ]
    }
  },
  methods: {
    getOptionGroupDesc(option) {
      switch (option) {
        case 'oasis':
          return this.$t(
            'Engagement_Category_National_Exclusion_GroupOasisDesc'
          )
        default:
          return this.$t(
            'Engagement_Category_National_Exclusion_GroupTechssonDesc'
          )
      }
    },
    getOptionGroupName(option) {
      switch (option) {
        case 'oasis':
          return this.$t('Engagement_Category_National_Exclusion_GroupOasis')
        default:
          return this.$t('Engagement_Category_National_Exclusion_GroupTechsson')
      }
    },
    getOptionName(option) {
      return nationalExclusionTypeLabels[option]
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/EngagementCategoriesSettingsSection.vue